import { WechatMessageType } from "../..";
import EventBus from "../event-bus";

const receiveMessageHook = new EventBus<WechatMessageType>(
  "receiveMessageHook"
);

export default receiveMessageHook;
